import { yupResolver } from "@hookform/resolvers/yup";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import ReactFlagsSelect from "react-flags-select";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import ExcelFile from "../../assets/downloadtemplate.xlsx";
import RRCurrencyInput from "../../common/components/CurrencyInput";
import RRPhoneInput from "../../common/components/PhoneInput";
import {
  currencyData,
  DataProtection,
  industryData,
  loanPurposeData,
  TermsConditions,
} from "../../common/constants";
import datehelper from "../../common/helper/datehelper";
import Notification from "../../common/notification/notification.component";
import { validationSchema } from "../../schemas/loanAppValidationSchema";
import ApiService, { ApiUrls } from "../../service/ApiService";
import ConfirmModal from "./ConfirmModal";
import RRTextField from "../../common/components/TextField";
import { Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { NonSGLoanApplicationDocument } from "../../common/constants/non-sg-loan.constant";
import {
  LoanForm,
  LoanFormContent,
  LoanFormHeader,
  LoanFormSectionHead,
  LoanFormSection,
  SubmitBtnStyled,
  FilesStyled,
  UploadSection,
} from "./LoanApp.component.style";
import InfoIcon from "@mui/icons-material/Info";
import ClearIcon from "@mui/icons-material/Clear";

const LoanApp = () => {
  const regex = {
    alphabetOnly: /^(?:(?=^.*([a-z]|[A-Z]))(([a-z]|[A-Z]))|([a-z]|[A-Z]))/g,
    alphaNumeric: /^[A-Za-z0-9]+$/,
    alphabetAndNumber:
      /^(?:(?=^.*([0-9]|[a-z]|[A-Z]))(([0-9]|[a-z]|[A-Z]))|([0-9]|[a-z]|[A-Z]))/g,
    alphaNumericHyphenAndForwardSlash: /^[A-Za-z0-9\/-]+$/,
    alphaNumericHyphenAndPlus: /^[A-Za-z0-9+-]+$/,
  };

  const isRRF = window.location.href.toLocaleLowerCase().includes("rrf");
  const getLoanType = () => {
    const path = window.location.pathname.toLowerCase();
    if (path.includes("pharmacy4less")) {
      return "P4L";
    }
    return "PLD"; // default case
  };

  const businessRegCertRef = useRef();
  const bankStatementsRef = useRef();
  const financeStatementsRef = useRef();
  const gstStatementsRef = useRef();
  const passport1Ref = useRef();
  const utilityBills1Ref = useRef();
  const revenueFinancingRef = useRef();
  const passport2Ref = useRef();
  const utilityBills2Ref = useRef();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const [dateValue, setDateValue] = useState({
    businessDate: null,
    videoCallDate1: null,
    videoCallDate2: null,
  });
  const [hideProgress, setHideProgress] = useState(true);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [country, setCountry] = useState({
    code: "AU",
    name: "Australia",
  });
  const [isFileChanged, setFileChanged] = useState(false);
  const [timeValue, setTimeValue] = useState({
    videoCallTime1: null,
    videoCallTime2: null,
  });
  const [secondDirector] = useState(false); // Always false since we only have 1 director
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);

  const {
    watch,
    register,
    setValue,
    getValues,
    resetField,
    reset,
    handleSubmit,
    trigger,
    setError,
    clearErrors,
    formState: { errors, submitCount, isValid },
  } = useForm({
    resolver: yupResolver(
      isRRF
        ? Yup.object().shape({
            ...validationSchema,
            revenueFinancing: Yup.mixed()
              .test(
                "required",
                "Please upload Revenue Detail Document.",
                file => {
                  if (file && file.length) return true;
                  else return false;
                }
              )
              .test("required.", "Please upload xlsx file only.", file => {
                if (file && file.length) {
                  var inValidFiles = [];
                  for (var f = 0; f < file.length; f++) {
                    if (
                      _.includes(
                        ["xlsx"],
                        _.toLower(_.last(_.split(file[f]?.name, ".")))
                      ) === false
                    ) {
                      inValidFiles.push(file[f]);
                    }
                  }
                  if (inValidFiles.length > 0) {
                    return false;
                  } else {
                    return true;
                  }
                }
              }),
          })
        : Yup.object().shape({ ...validationSchema })
    ),
    mode: "onTouched",
    reValidateMode: "onChange",
    defaultValues: {
      locationSelect: {
        country: "Australia",
        countryCode: "AU",
      },
      applicantNationality: {
        countryCode: "AU",
        country: "Australia",
      },
      businessAddrCountry: {
        countryCode: "AU",
        country: "Australia",
      },
      industry: "Others",
      businessCountry: {
        country: "Australia",
        countryCode: "AU",
      },

      // applicantName: "Test",
      residentialStatus: "...",
      // residentialAddr: "Test Address",
      // applicantZip: "2000",
      // applicantEmail: "test23@example.com.au",
      // applicantPhone: "+61412345678",
      businessRegCert: [],
      checkTerms: false,
      checkDataProtection: false,
      checkAll: false,
    },
  });

  useEffect(() => {
    const subscription = watch(values => {
      const allChecked =
        values.checkTerms && values.checkDataProtection && values.checkAll;
      setIsSubmitEnabled(allChecked);
    });

    return () => subscription.unsubscribe();
  }, [watch]);

  function hasDuplicates(a) {
    return _.uniq(a).length !== a.length;
  }

  useEffect(() => {
    fileList();
  }, [isFileChanged]);

  const onDateChange = (value, fieldName) => {
    if (value) {
      setDateValue({
        ...dateValue,
        [fieldName]: value,
      });
      setValue(fieldName, datehelper.formatedDate(value), {
        shouldValidate: true,
      });
    }
  };

  const onTimeChange = (value, fieldName) => {
    if (value) {
      setTimeValue({
        ...timeValue,
        [fieldName]: value,
      });
      setValue(fieldName, datehelper.formatedDate(value), {
        shouldValidate: true,
      });
    }
  };

  const onCountrySelect = (countryCode, id) => {
    if (id === "locationSelect") {
      const countryData = _.filter(currencyData, ["code", countryCode]);
      setCountry(countryData[0]);
      setValue(
        "businessCountry",
        {
          countryCode: countryCode,
          country: _.find(currencyData, function (c) {
            return c.code === countryCode;
          })?.name,
        },
        {
          shouldValidate: true,
          shouldDirty: true,
        }
      );
    }
    if (id) {
      setValue(
        id,
        {
          countryCode: countryCode,
          country: _.find(currencyData, function (c) {
            return c.code === countryCode;
          })?.name,
        },
        {
          shouldValidate: true,
          shouldDirty: true,
        }
      );
    }
  };

  const mergeDate = (date, time) => {
    var callDate = new Date();
    callDate.setDate(date.getDate());
    callDate.setMonth(date.getMonth());
    callDate.setFullYear(date.getFullYear());
    callDate.setHours(time.getHours(), time.getMinutes());
    return callDate;
  };

  const formatABN = value => {
    // Remove all spaces first
    const cleaned = value.replace(/[^\d]/g, "");
    // Add spaces after every 2,5,8 characters
    return cleaned.replace(/^(\d{2})(\d{3})(\d{3})(\d{3})$/, "$1 $2 $3 $4");
  };

  const onConfirm = async () => {};
  console.log("Error :", errors);
  const onSubmit = async formData => {    
    // Show alert for form submission
    setOpen(true);
    setSeverity("success");
    setMessage("Your loan application form is being submitted. Please wait...");

    console.log(formData);

    setHideProgress(false);

    const directorPayload = {
      directorName: formData.directorName1,
      personalIdentificationNumber: formData.personalIdentificationNumber,
      driverLicenseNumber: formData.driverLicenseNumber,
      shareholding: formData.shareholding1,
      address: formData.directorAddress1,
      zipCode: formData.directorZipCode1,
      directorSuburb: formData.directorSuburb,
      email: formData.directorEmail1,
      phone: formData.directorPhone1,
      country: formData.directorCountry1?.country,
      state: formData.directorState,
    };

    const locationPayload = {
      country: formData.locationSelect.country,
      loanType: isRRF ? "RRF" : getLoanType(),
    };

    //Requirements Section Payload
    const loanPayload = {
      amount: formData.loanAmount,
      tenure: formData.loanTenure,
      purpose: formData.loanPurpose,
    };

    //Company Information Payload
    // const businessPayload = {
    //   regNo: formData.businessRegNum,
    //   entityType: formData.entityType,
    //   tradingName: formData.tradingName,
    //   name: formData.businessName,
    //   regDate: formData.businessDate,
    //   incorporation: formData.businessCountry?.country,
    //   industry: formData.industry,
    //   address: formData.businessAddr,
    //   suburb: formData.businessSuburb,
    //   zipCode: formData.businessZipCode,
    //   country: formData.businessAddrCountry?.country,
    //   state: formData.businessState,
    //   email: formData.businessEmail,
    //   phone: formData.businessPhone,
    // };

    const businessPayload = {
      regNo: formData.businessRegNum,
      name: formData.businessName,
      tradingName: formData.tradingName,
      type: formData.entityType,
      email: formData.businessEmail,
      phone: formData.businessPhone,
      address: formData.businessAddr,
      suburb: formData.businessSuburb,
      country: formData.businessAddrCountry?.country || "Australia",
      state: formData.businessState,
      zipCode: formData.businessZipCode,
    };

    const applicantPayload = {
      name: formData.directorName1,
      nationality: "Australia",
      resStatus: "...",
      address: formData.directorAddress1,
      zipCode: formData.directorZipCode1,
      email: formData.directorEmail1,
      phone: formData.directorPhone1,
    };

    const statementsPayload = {
      bank: formData.bankStatements,
      financial: formData.financeStatements,
      revenueFinancing: formData.revenueFinancing,
    };

    const payload = {
      location: locationPayload,
      loan: loanPayload,
      business: businessPayload,
      applicant: applicantPayload,
      directors: directorPayload,
    };

    const apiData = new FormData();
    apiData.append("formData", JSON.stringify(payload));
    for (var b = 0; b < statementsPayload.bank.length; b++) {
      apiData.append(
        NonSGLoanApplicationDocument.BANK_STATEMENTS,
        statementsPayload.bank[b]
      );
    }
    if (statementsPayload.financial && statementsPayload.financial.length) {
      for (var f = 0; f < statementsPayload.financial.length; f++) {
        apiData.append(
          NonSGLoanApplicationDocument.FINANCIAL_STATEMENTS,
          statementsPayload.financial[f]
        );
      }
    }

    if (isRRF) {
      apiData.append(
        NonSGLoanApplicationDocument.REVENUE_FINANCING,
        statementsPayload.revenueFinancing[0]
      );
    }
    if (formData.businessRegCert && formData.businessRegCert.length) {
      for (var b = 0; b < formData.businessRegCert.length; b++) {
        apiData.append(
          NonSGLoanApplicationDocument.BUSINESS_REGISTRATION_CERTIFICATE,
          formData.businessRegCert[b]
        );
      }
    }
    console.log(apiData);
    const apiResponse = await ApiService.post(ApiUrls.LoanApplication, apiData);

    if (apiResponse && apiResponse.status === 200) {
      navigate(
        `/ThankYouPharmacy/${apiResponse?.data}/${formData.businessName}/${formData.directorName1}/${formData.directorPhone1}/${formData.directorEmail1}`
      );
    } else {
      setOpen(true);
      setSeverity("error");
      setMessage(`An error occurred. Please try again later.`);
      setHideProgress(true);
    }
  };

  const closeAlert = () => {
    setOpen(false);
  };

  function renderErrorDesc(key, isError = true, subKey = "") {
    return (
      (errors?.[key]?.[subKey]?.message || errors?.[key]?.message) && (
        <p
          className={`form-input-desc${isError ? "-error" : ""}`}
          style={{ marginBottom: "5px" }}
        >
          {subKey ? errors?.[key]?.[subKey]?.message : errors?.[key]?.message}
        </p>
      )
    );
  }

  const fileList = (fieldName, ref) => {
    const files = getValues(`${fieldName}`);
    if (files?.length > 0) {
      return (
        <>
          {Object.keys(files).map(file => {
            return (
              <FilesStyled
                label={files[file].name}
                key={file}
                title={files[file].name}
                className="uploadCapsule"
                onDelete={() => onRemove(files[file], fieldName, ref, file)}
                deleteIcon={
                  <ClearIcon
                    sx={{
                      color: "#FF3636 !important",
                      fontSize: "18px !important",
                    }}
                  />
                }
              />
            );
          })}
        </>
      );
    }
    return null;
  };

  const onRemove = (file, fieldName, ref, index) => {
    console.log(index);

    setFileChanged(!isFileChanged);
    const files = getValues(`${fieldName}`);
    files.splice(index, 1);
    const setFiles = _.cloneDeep(files);

    if (setFiles.length === 0) {
      if (ref && ref.current) {
        ref.current.value = null;
      }
      resetField(fieldName);
      setValue(fieldName, [], { shouldValidate: true });
      trigger(fieldName); // Trigger validation when all files are removed
    } else {
      resetField(fieldName);
      setValue(fieldName, setFiles, { shouldValidate: true });
    }
  };

  const handleThankyouModalClose = () => {
    setConfirmModalOpen(false);
  };

  // const onPhoneNumberChange = (e, id) => {
  //   if (e.target.value) {
  //     setValue(id, e.target.value, { shouldValidate: true });
  //   } else {
  //     setValue(id, e.target.value, { shouldValidate: false });
  //   }
  // };

  // const onPhoneNumberChange = (e, id) => {
  //   let value = e.target.value.replace(/\D/g, ""); // Remove non-digits

  //   // Ensure it starts with 04 and has max 10 digits
  //   if (value.startsWith("04")) {
  //     value = value.slice(0, 10);
  //   } else if (value.startsWith("4")) {
  //     // If starts with 4, add the 0
  //     value = "0" + value.slice(0, 9);
  //   } else {
  //     // Otherwise clear invalid input
  //     value = "";
  //   }

  //   setValue(id, value, { shouldValidate: true });
  // };

  const onPhoneNumberChange = (e, id) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-digits
    value = value.slice(0, 10); // Keep only first 10 digits
    setValue(id, value, { shouldValidate: true });
  };

  const onCurrencyChange = (value, name) => {
    if (value) {
      setValue(name, _.toNumber(value), {
        shouldValidate: true,
        shouldDirty: true,
      });      
    } else {
      resetField(name);
    }
  };

  const onChangeFile = e => {
    const fileId = e.target.id;
    const files = Array.from(e.target.files || []);

    // Check if any non-PDF files
    const hasInvalidFiles = files.some(file => {
      const extension = file.name.split(".").pop().toLowerCase();
      return extension !== "pdf";
    });

    if (hasInvalidFiles) {
      // Clear the input
      e.target.value = "";

      // Set a manual error message
      setError(fileId, {
        type: "manual",
        message: "Only PDF files are allowed",
      });

      // Keep any existing files
      const currentFiles = getValues(fileId) || [];
      setValue(fileId, currentFiles, { shouldValidate: false });

      return;
    } else {
      // Clear any manual errors if files are valid
      clearErrors(fileId);
    }

    // Get current files
    const currentFiles = getValues(fileId) || [];

    // Check for duplicate files
    let hasDuplicates = false;

    if (files.length > 0) {
      // Check each new file against existing files
      for (const newFile of files) {
        const isDuplicate = currentFiles.some(
          existingFile => existingFile.name === newFile.name
        );

        if (isDuplicate) {
          hasDuplicates = true;
          break; // Exit loop once we find a duplicate
        }
      }
    }

    // If duplicates found, show error and don't update files
    if (hasDuplicates) {
      // Clear the file input
      e.target.value = "";

      // Set validation error
      setError(fileId, {
        type: "manual",
        message: "File with same name already uploaded",
      });

      return; // Exit function to prevent file update
    }

    // No duplicates, proceed with upload
    let uploadedFiles = [];
    if (e.target.multiple) {
      uploadedFiles = [...currentFiles];
      files.forEach(file => {
        uploadedFiles.push(file);
      });
    } else {
      uploadedFiles = files.length > 0 ? files : currentFiles;
    }

    setFileChanged(!isFileChanged);
    e.preventDefault();
    setValue(fileId, uploadedFiles, { shouldValidate: true });

    // Always reset the file input value after processing
    // This ensures the onChange event will trigger even if the same file is selected again
    setTimeout(() => {
      e.target.value = "";
    }, 100);
  };

  return (
    <LoanForm
      style={{ overflow: "hidden" }}
      className="loanAppForm loanformNew"
    >
      {!open && !hideProgress ? (
        <Backdrop sx={{ color: "#fff", zIndex: 9999 }} open={!open}>
          <Stack spacing={1} alignItems="center">
            <CircularProgress color="inherit" />
          </Stack>
        </Backdrop>
      ) : (
        <Notification
          open={open}
          severity={severity}
          message={message}
          closeAlert={closeAlert}
        />
      )}
      <LoanFormHeader className="loanAppHeader">
        <div className="container">
          <div className="logo">
            <img
              src="img/pharmacy4LessLogo.png"
              height={60}
              alt="logo"
              style={{ marginRight: "30px" }}
            />
            <img src="img/credilinqLogoNew.svg" height={50} alt="logo" />
          </div>
          <div className="headerContent">Application Form</div>
        </div>
      </LoanFormHeader>
      <LoanFormContent className="wizard_wrapper" id="start">
        <div className="container">
          <form
            // id="wrapped"
            // method="post"
            // encType="multipart/form-data"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Box
              sx={{
                '[class*="ReactFlagsSelect-module_selectBtn"]': {
                  padding: "7px 10px",
                },
                '[class*="ReactFlagsSelect-module_selectValue"]': {
                  flexGrow: 5,
                },
                'ul[class*="ReactFlagsSelect-module_selectOptions"]': {
                  margin: 0,
                },
              }}
              id="middle-lg-wizard  d-flex justify-content-center col-xl-12"
            >
              <div className="form-group justify-content-center ">
                <Grid>
                  <LoanFormSection>
                    <LoanFormSectionHead>
                      <div className="title">Requirements</div>
                      <Tooltip
                        title="Please provide requirements"
                        placement="left"
                      >
                        <InfoIcon fontSize="large" />
                      </Tooltip>
                    </LoanFormSectionHead>
                    <Grid container spacing={4}>
                      <Grid item xs={12} md={6}>
                        <label htmlFor="loanAmount" className="form-label">
                          Required Funds (AUD)
                        </label>
                        <RRCurrencyInput
                          locale={"en-AU"}
                          currency={"AUD"}
                          value={getValues("loanAmount")}
                          {...register("loanAmount")}
                          inputProps={{
                            id: "loanAmount",
                            name: "loanAmount",
                            placeholder:
                              "How much are you looking for? eg: $100,000",
                            className: "form-control required",
                            onBlur: () => trigger("loanAmount"),
                          }}
                          onChange={onCurrencyChange}
                        />
                        {renderErrorDesc("loanAmount")}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label htmlFor="loanTenure" className="form-label">
                          Term (months)
                        </label>
                        <RRTextField
                          fieldMargin={"none"}
                          formRegister={register}
                          fieldType="num"
                          fieldName={"loanTenure"}
                          fieldPlaceholder="How long will you need the funds? eg: 2 months"
                          max={10}
                        />
                        {renderErrorDesc("loanTenure")}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label htmlFor="loanPurpose" className="form-label">
                          Purpose
                        </label>
                        <RRTextField
                          fieldMargin={"none"}
                          formRegister={register}
                          fieldType="text"
                          fieldName={"loanPurpose"}
                          fieldPlaceholder="How are you going to use the funds ?"
                        />
                        {renderErrorDesc("loanPurpose")}
                      </Grid>
                    </Grid>
                  </LoanFormSection>
                  <LoanFormSection>
                    <LoanFormSectionHead>
                      <div className="title">Company Information</div>
                      <Tooltip
                        title="Please provide company information"
                        placement="left"
                      >
                        <InfoIcon fontSize="large" />
                      </Tooltip>
                    </LoanFormSectionHead>

                    <Grid container spacing={4}>
                      <Grid item xs={12} md={6}>
                        <label htmlFor="businessRegNum" className="form-label">
                          ABN Number
                        </label>
                        <input
                          type="text"
                          name="businessRegNum"
                          id="businessRegNum"
                          className="form-control required"
                          maxLength={11}
                          placeholder="Enter your ABN eg:10 100 100 100"
                          {...register("businessRegNum", {
                            onChange: e => {
                              // Remove non-digits first
                              const digitsOnly = e.target.value.replace(
                                /[^\d]/g,
                                ""
                              );

                              // Format the ABN
                              const formatted = formatABN(digitsOnly);
                              setValue("businessRegNum", formatted);

                              // If we have exactly 11 digits, trigger validation to clear error
                              if (digitsOnly.length === 11) {
                                // Clear error manually
                                clearErrors("businessRegNum");
                                // Trigger validation to update form state
                                trigger("businessRegNum");
                              }
                            },
                            onBlur: () => trigger("businessRegNum"), // Also validate on blur
                          })}
                        />
                        {renderErrorDesc("businessRegNum")}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label htmlFor="businessName" className="form-label">
                          Entity Name
                        </label>
                        <input
                          type="text"
                          name="businessName"
                          id="businessName"
                          maxLength={100}
                          className="form-control required"
                          placeholder="Enter your entity name"
                          {...register("businessName")}
                        />
                        {renderErrorDesc("businessName")}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label htmlFor="tradingName" className="form-label">
                          Trading Name (Optional)
                        </label>
                        <input
                          type="text"
                          name="tradingName"
                          id="tradingName"
                          className="form-control required"
                          placeholder="Enter your trading name"
                          {...register("tradingName")}
                        />
                        {renderErrorDesc("tradingName")}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <label htmlFor="entityType" className="form-label">
                          Entity Type
                        </label>
                        <input
                          type="text"
                          name="entityType"
                          id="entityType"
                          className="form-control required"
                          placeholder="Enter type of entity eg: sole trader, partnership, private limited or a trust"
                          {...register("entityType")}
                        />
                        {renderErrorDesc("entityType")}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label htmlFor="businessEmail" className="form-label">
                          Email Address
                        </label>
                        <input
                          type="text"
                          name="businessEmail"
                          id="businessEmail"
                          maxLength={255}
                          className="form-control required"
                          placeholder="Enter your email address, the offer would be sent to this email address"
                          {...register("businessEmail")}
                        />
                        {renderErrorDesc("businessEmail")}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label htmlFor="businessPhone" className="form-label">
                          Mobile Number
                        </label>
                        <input
                          type="text"
                          name="businessPhone"
                          id="businessPhone"
                          className="form-control required"
                          placeholder="Enter your mobile number"
                          maxLength={10} // To accommodate +61 + 9 digits
                          value={getValues("businessPhone") || ""}
                          onChange={e =>
                            onPhoneNumberChange(e, "businessPhone")
                          }
                          onBlur={() => trigger("businessPhone")}
                        />
                        {/* <RRPhoneInput
                          onChange={({ e }) =>onPhoneNumberChange(e, "businessPhone")}
                          country="AU"
                          value={getValues("businessPhone")}
                          inputProps={{
                            name: "businessPhone",
                            required: true,
                            autoFocus: true,
                            placeholder: "Enter your Mobile Number",
                            onBlur: () => trigger("businessPhone")
                          }}
                        /> */}
                        {renderErrorDesc("businessPhone")}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label htmlFor="businessAddr" className="form-label">
                          Street Address
                        </label>
                        <input
                          type="text"
                          name="businessAddr"
                          id="businessAddr"
                          maxLength={500}
                          className="form-control required"
                          placeholder="Enter your address of company"
                          {...register("businessAddr")}
                        />
                        {renderErrorDesc("businessAddr")}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <label htmlFor="businessSuburb" className="form-label">
                          Suburb
                        </label>
                        <input
                          type="text"
                          name="businessSuburb"
                          id="businessSuburb"
                          maxLength={255}
                          className="form-control required"
                          placeholder="Enter your company suburb"
                          {...register("businessSuburb")}
                        />
                        {renderErrorDesc("businessSuburb")}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <label htmlFor="businessState" className="form-label">
                          State / Territory
                        </label>
                        <input
                          type="text"
                          name="businessState"
                          id="businessState"
                          maxLength={255}
                          className="form-control required"
                          placeholder="Enter your State / Territory of company"
                          {...register("businessState")}
                        />
                        {renderErrorDesc("businessState")}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <label htmlFor="zipCode" className="form-label">
                          Area Code
                        </label>
                        <input
                          type="text"
                          name="businessZipCode"
                          id="businessZipCode"
                          maxLength={6}
                          className="form-control required"
                          placeholder="Enter your area code of company"
                          {...register("businessZipCode")}
                          onKeyPress={e => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                        />
                        {renderErrorDesc("businessZipCode")}
                      </Grid>
                    </Grid>
                  </LoanFormSection>
                  <LoanFormSection>
                    <LoanFormSectionHead>
                      <div className="title">Upload Documents</div>
                      <Tooltip title="Please upload documents" placement="left">
                        <InfoIcon fontSize="large" />
                      </Tooltip>
                    </LoanFormSectionHead>
                    <Grid container spacing={4}>
                      <Grid item xs={12} md={6}>
                        <label htmlFor="bankStatements" className="semi-bold">
                          Bank Statements
                        </label>
                        <UploadSection>
                          <div className="uploadWrap">
                            <div className="upload left">
                              <input
                                type="file"
                                name="bankStatements"
                                accept=".pdf"
                                id="bankStatements"
                                className="form-control required"
                                placeholder="SG$"
                                onChange={onChangeFile}
                                ref={bankStatementsRef}
                                multiple
                              />
                              <img alt="upload" src={"img/upload.png"} />
                            </div>
                            <div className="right content">
                              <ul>
                                <li
                                  className="small text-left"
                                  style={{ marginTop: "15px" }}
                                >
                                  PDFs (not scanned copies) of company's
                                  operating bank current account(s) statements
                                  for the past 6 months.
                                </li>
                                <li
                                  className="small text-left"
                                  style={{ marginTop: "15px" }}
                                >
                                  Example: If today is {new Date().getDate()}{" "}
                                  {new Date().toLocaleString("default", {
                                    month: "long",
                                  })}{" "}
                                  {new Date()
                                    .getFullYear()
                                    .toString()
                                    .slice(-2)}
                                  , then please upload bank statements from{" "}
                                  {(() => {
                                    // Get the first day of current month
                                    const firstDayOfCurrentMonth = new Date();
                                    firstDayOfCurrentMonth.setDate(1);

                                    // Get the last day of previous month (end date)
                                    const endDate = new Date(
                                      firstDayOfCurrentMonth
                                    );
                                    endDate.setDate(0);

                                    // Get the start date (6 months before the end date)
                                    const startDate = new Date(endDate);
                                    startDate.setMonth(endDate.getMonth() - 5);

                                    return startDate.toLocaleString("default", {
                                      month: "short",
                                    });
                                  })()}{" "}
                                  {(() => {
                                    const firstDayOfCurrentMonth = new Date();
                                    firstDayOfCurrentMonth.setDate(1);
                                    const endDate = new Date(
                                      firstDayOfCurrentMonth
                                    );
                                    endDate.setDate(0);
                                    const startDate = new Date(endDate);
                                    startDate.setMonth(endDate.getMonth() - 5);
                                    return startDate
                                      .getFullYear()
                                      .toString()
                                      .slice(-2);
                                  })()}{" "}
                                  to{" "}
                                  {(() => {
                                    const firstDayOfCurrentMonth = new Date();
                                    firstDayOfCurrentMonth.setDate(1);
                                    const endDate = new Date(
                                      firstDayOfCurrentMonth
                                    );
                                    endDate.setDate(0);
                                    return endDate.toLocaleString("default", {
                                      month: "short",
                                    });
                                  })()}{" "}
                                  {(() => {
                                    const firstDayOfCurrentMonth = new Date();
                                    firstDayOfCurrentMonth.setDate(1);
                                    const endDate = new Date(
                                      firstDayOfCurrentMonth
                                    );
                                    endDate.setDate(0);
                                    return endDate
                                      .getFullYear()
                                      .toString()
                                      .slice(-2);
                                  })()}
                                  (both months inclusive).
                                </li>
                                <li
                                  className="small text-left"
                                  style={{ marginTop: "15px" }}
                                >
                                  If your company is multi-banked, then please
                                  upload 6 months bank statements for each bank
                                  account.
                                </li>
                              </ul>
                            </div>
                          </div>

                          {renderErrorDesc("bankStatements")}
                          {fileList("bankStatements", bankStatementsRef)}
                        </UploadSection>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label
                          htmlFor="financeStatements"
                          className="semi-bold"
                        >
                          Financial Statements
                        </label>
                        <UploadSection>
                          <div className="uploadWrap">
                            <div className="upload left">
                              <input
                                type="file"
                                name="financeStatements"
                                accept=".pdf"
                                id="financeStatements"
                                className="form-control required"
                                onChange={onChangeFile}
                                ref={financeStatementsRef}
                                multiple
                              />
                              <img alt="upload" src={"img/upload.png"} />
                            </div>
                            <div className="right content">
                              <ul>
                                <li
                                  className="small text-left"
                                  style={{ marginTop: "15px" }}
                                >
                                  Upload last years's financial statements
                                  <br />
                                  (scanned audited financials or pdf).
                                </li>
                                <li
                                  className="small text-left"
                                  style={{ marginTop: "15px" }}
                                >
                                  Please include profit & loss statements and an
                                  asset liability statement.
                                </li>
                              </ul>
                            </div>
                          </div>

                          {renderErrorDesc("financeStatements")}
                          {fileList("financeStatements", financeStatementsRef)}
                        </UploadSection>
                      </Grid>
                      {isRRF ? (
                        <Grid item xs={12} md={6}>
                          <label htmlFor="bankStatements" className="semi-bold">
                            Upload Revenue Details
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="file"
                            name="revenueFinancing"
                            accept=".xlsx"
                            id="revenueFinancing"
                            className="form-control required"
                            onChange={onChangeFile}
                            ref={revenueFinancingRef}
                          />
                          {renderErrorDesc("revenueFinancing")}
                          {fileList("revenueFinancing", revenueFinancingRef)}
                          <ul>
                            <li
                              className="small text-left"
                              style={{ marginTop: "15px" }}
                            >
                              You can download the sample template:{" "}
                              <a href={ExcelFile}>Click Here</a>.
                            </li>
                            <li
                              className="small text-left"
                              style={{ marginTop: "15px" }}
                            >
                              The instructions are clearly mentioned in the
                              document on how to complete/fill
                            </li>
                            <li
                              className="small text-left"
                              style={{ marginTop: "15px" }}
                            >
                              Do not change any headers and request you to fill
                              all information requested
                            </li>
                            <li
                              className="small text-left"
                              style={{ marginTop: "15px" }}
                            >
                              Once you fill the revenue information, please
                              upload the file using Choose File button
                            </li>
                          </ul>
                        </Grid>
                      ) : null}
                    </Grid>
                  </LoanFormSection>

                  <LoanFormSection>
                    <LoanFormSectionHead>
                      <div className="title">Director Information</div>
                      <Tooltip
                        title="Please provide director information"
                        placement="left"
                      >
                        <InfoIcon fontSize="large" />
                      </Tooltip>
                    </LoanFormSectionHead>

                    <Grid container spacing={4}>
                      <Grid item xs={12} md={6}>
                        <label htmlFor="directorName1" className="form-label">
                          Full Name
                        </label>
                        <input
                          type="text"
                          name="directorName1"
                          id="directorName1"
                          maxLength={100}
                          className="form-control required"
                          placeholder="Enter your First & Last name"
                          {...register("directorName1")}
                        />
                        {renderErrorDesc("directorName1")}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <label
                          htmlFor="driverLicenseNumber"
                          className="form-label"
                        >
                          Driver's License Number
                        </label>
                        <RRTextField
                          fieldMargin={"none"}
                          formRegister={register}
                          fieldName={"driverLicenseNumber"}
                          fieldPlaceholder="Enter your driver's license number"
                        />
                        {renderErrorDesc("driverLicenseNumber")}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <label htmlFor="directorEmail1" className="form-label">
                          Email Address
                        </label>
                        <input
                          type="text"
                          name="directorEmail1"
                          id="directorEmail1"
                          maxLength={255}
                          className="form-control required"
                          placeholder="Enter your email address"
                          {...register("directorEmail1")}
                        />
                        {renderErrorDesc("directorEmail1")}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <label htmlFor="directorPhone1" className="form-label">
                          Mobile Number
                        </label>
                        <input
                          type="text"
                          name="directorPhone1"
                          id="directorPhone1"
                          className="form-control required"
                          placeholder="Enter your personal mobile number"
                          maxLength={10} // To accommodate +61 + 9 digits
                          value={getValues("directorPhone1") || ""}
                          onChange={e =>
                            onPhoneNumberChange(e, "directorPhone1")
                          }
                          onBlur={() => trigger("directorPhone1")}
                        />
                        {renderErrorDesc("directorPhone1")}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <label
                          htmlFor="directorAddress1"
                          className="form-label"
                        >
                          Street address
                        </label>
                        <input
                          type="text"
                          name="directorAddress1"
                          id="directorAddress1"
                          maxLength={500}
                          className="form-control required"
                          style={{ height: "calc(2.65rem + 2px)" }}
                          placeholder="Enter your address  of residence"
                          {...register("directorAddress1")}
                        />
                        {renderErrorDesc("directorAddress1")}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <label htmlFor="directorsuburb" className="form-label">
                          Suburb
                        </label>
                        <input
                          type="text"
                          name="directorSuburb"
                          id="directorSuburb"
                          maxLength={255}
                          className="form-control required"
                          placeholder="Enter your suburb of residence"
                          {...register("directorSuburb")}
                        />
                        {renderErrorDesc("directorSuburb")}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <label htmlFor="directorState" className="form-label">
                          State / Territory
                        </label>
                        <input
                          type="text"
                          name="directorState"
                          id="directorState"
                          maxLength={255}
                          className="form-control required"
                          placeholder="Enter your state / territory of residence"
                          {...register("directorState")}
                        />
                        {renderErrorDesc("directorState")}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <label
                          htmlFor="directorZipCode1"
                          className="form-label"
                        >
                          Area Code
                        </label>
                        <input
                          type="text"
                          name="directorZipCode1"
                          id="directorZipCode1"
                          maxLength={6}
                          className="form-control required"
                          placeholder="Enter your area code of residence"
                          {...register("directorZipCode1")}
                          onKeyPress={e => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                        />
                        {renderErrorDesc("directorZipCode1")}
                      </Grid>
                    </Grid>
                  </LoanFormSection>
                  <LoanFormSection>
                    <LoanFormSectionHead>
                      <div className="title">Authorisation & Consent</div>
                      <Tooltip title="Authorisation & Consent" placement="left">
                        <InfoIcon fontSize="large" />
                      </Tooltip>
                    </LoanFormSectionHead>
                    <Box
                      sx={{
                        fontSize: "18px;",
                        "& *:before,&:after": { content: "none" },
                      }}
                    >
                      <Box sx={{ display: "flex", gap: "2px", mb: 2 }}>
                        <Checkbox
                          className="form-check-input"
                          id="checkTerms"
                          name="checkTerms"
                          color="success"
                          {...register("checkTerms")}
                        />
                        <label
                          className="form-check-label small"
                          htmlFor="checkTerms"
                          style={{ paddingTop: "10px" }}
                        >
                          I acknowledge that I have read and understood the
                          Standard{" "}
                          <a
                            href={TermsConditions}
                            target={"_blank"}
                            rel="noopener noreferrer"
                          >
                            Terms & Conditions
                          </a>
                        </label>
                      </Box>
                      <Box sx={{ display: "flex", gap: "2px", mb: 2 }}>
                        <Checkbox
                          className="form-check-input"
                          type="checkbox"
                          id="check-dataprotection"
                          name="checkDataProtection"
                          color="success"
                          {...register("checkDataProtection")}
                        />
                        <label
                          className="form-check-label small"
                          htmlFor="check-dataprotection"
                          style={{ paddingTop: "10px" }}
                        >
                          By checking this box you confirm that CrediLinq.AI Pte
                          Ltd and AsiaLinq Investment Pte Ltd can fetch your
                          business credit bureau from authorized providers for
                          underwriting purposes.{" "}
                        </label>
                      </Box>
                      <Box sx={{ display: "flex", gap: "2px" }}>
                        <Checkbox
                          color="success"
                          className="form-check-input"
                          type="checkbox"
                          id="checkAll"
                          name="checkAll"
                          {...register("checkAll")}
                        />
                        <label
                          className="form-check-label small"
                          htmlFor="checkAll"
                        >
                          I acknowledge that I have read and understood the
                          above{" "}
                          <a
                            href={DataProtection}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Data Protection Notice,
                          </a>{" "}
                          and consent to the collection, use and disclosure of
                          my personal data by CrediLinq.Ai Pte Ltd and AsiaLinq
                          Investments Pte Ltd for the purpose set out in Notice
                        </label>
                      </Box>
                    </Box>
                  </LoanFormSection>
                  <div
                    id="bottom-wizard"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <SubmitBtnStyled
                      type="submit"
                      name="submit"
                      className="btn_1"
                      value="Submit"
                      disabled={!isSubmitEnabled || !isValid}
                    >
                      Submit
                    </SubmitBtnStyled>
                  </div>
                </Grid>
              </div>
            </Box>
          </form>
        </div>
      </LoanFormContent>
    </LoanForm>
  );
};

export default LoanApp;
